import React from 'react';
import { DropdownMenu, DropdownToggle, Dropdown, Input, DropdownItem } from 'reactstrap';
import { useProductSearch } from 'hooks/useProductSearch';

export const ProductSearchBar = () => {

  //Custom Hooks for Product Search
  const {
    searchValue,
    selectedField,
    dropdownOpen,
    searchFields,
    setSearchValue,
    toggleDropdown,
    handleFieldChange,
    handleSearch,
    handleClear,
    handleKeyPress,
  } = useProductSearch();

  return (
    <div
      className="d-flex align-items-center pt-4"
      style={{ marginLeft: '20px' }}
    >
      {/* search fields */}
      <div
        className="d-flex align-items-center gap-2"
        style={{ width: '620px' }}
      >
        {/* Input */}
        <Input
          type="text"
          bsSize="sm"
          className="form-control"
          id="search"
          placeholder="Search"
          aria-label="Search"
          style={{ width: '180px' }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          onKeyDown={handleKeyPress}
        />

        {/* Dropdown */}
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle
            tag="button"
            className="btn btn-light border btn-sm"
            id="dropdownMenuButton"
            style={{
              width: '180px',
              borderRadius: 0,
              height: '100%',
            }}
          >
            {selectedField}{' '}
            <i className="mdi mdi-chevron-down align-self-end"></i>
          </DropdownToggle>
          <DropdownMenu className="text-dark" bsSize="sm">
            {searchFields.map((field) => (
              <DropdownItem
                key={field.id}
                onClick={() => handleFieldChange(field.name)}
              >
                {field.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>

        {/* Search Button */}
        <button
          className="btn btn-soft-primary btn-sm"
          style={{ minWidth: '100px' }}
          aria-label="Find Now"
          onClick={handleSearch}
        >
          <i className="ri-search-line me-1"></i>
          Find Now
        </button>

        {/* Clear Button */}
        <button
          className="btn btn-outline-secondary btn-sm"
          style={{ minWidth: '80px' }}
          aria-label="Clear"
          onClick={handleClear}
        >
          <i className="ri-close-line me-1"></i>
          Clear
        </button>
      </div>
    </div>
  );
};